import { ProductApi } from './http-common';

const authorizationHeaders = () => {
  const token = localStorage.getItem('vue-token');

  return token ? { Authorization: `Bearer ${token}` } : {};
};

/** Every supplement, deactivated ones included. */
export const findAllSupplements = () => ProductApi
  .get('admin', { headers: authorizationHeaders() })
  .then(response => response.data);

export const findSupplementUnits = () => ProductApi
  .get('units', { headers: authorizationHeaders() })
  .then(response => response.data);

export const createSupplement = supplement => ProductApi
  .post('', supplement, { headers: authorizationHeaders() })
  .then(response => response.data);

export const updateSupplement = (id, supplement) => ProductApi
  .put(`${id}`, supplement, { headers: authorizationHeaders() })
  .then(response => response.data);

/** The backend only deactivates: offers and treatments keep pointing to the supplement. */
export const deactivateSupplement = id => ProductApi
  .delete(`${id}`, { headers: authorizationHeaders() })
  .then(response => response.data);

export const reactivateSupplement = id => ProductApi
  .put(`${id}/reactivate`, null, { headers: authorizationHeaders() })
  .then(response => response.data);
